import { useEffect, useRef } from 'react'
import { getChallenge } from '../utils/challenges'

// Fires callback with fresh challenge whenever action_challenges changes in any tab.
// Uses storage events (cross-tab) + 3s polling fallback (same-tab, edge cases).
export function useH2HSync(gameId, callback) {
  const cbRef = useRef(callback)
  cbRef.current = callback

  useEffect(() => {
    if (!gameId) return

    const check = () => {
      const ch = getChallenge(gameId)
      if (ch) cbRef.current(ch)
    }

    const onStorage = (e) => {
      if (e.key === 'action_challenges') check()
    }

    window.addEventListener('storage', onStorage)
    const timer = setInterval(check, 3000)
    check() // immediate initial read

    return () => {
      window.removeEventListener('storage', onStorage)
      clearInterval(timer)
    }
  }, [gameId])
}
